module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/brand/spotify-986b24f6558d76ff8218974a3cc075d3.svg";